export const getPeerAssessmentLink = ({
  author,
  userId,
  questionId,
  isEndJourney,
}: {
  author: string | undefined
  userId: string | undefined
  questionId: string
  isEndJourney: boolean
}) => {
  return `/peer-assessment/${author}/${userId}/${questionId}${
    isEndJourney ? '?type=endjourney' : ''
  }`
}

export const getPeerAssessmentLeadershipValuesLink = (
  author: string | undefined
) => {
  return `/peer-assessment/${author}/u/q/leadership-values`
}
